import { Main } from '@/components/_common/main';
import { BlogCard } from '@/components/blog-card';
import { getPostsServer } from '@lib/blog.server';
import { createFileRoute, ErrorComponent } from '@tanstack/react-router';

const Home = () => {
  const posts = Route.useLoaderData();

  return (
    <>
      <Main className="relative mt-16">
        <div className="container mx-auto px-4 py-8">
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {posts.map((post) => (
              <BlogCard key={post.slug} post={post} />
            ))}
          </div>

          {posts.length === 0 && (
            <div className="text-center py-12">
              <p className="text-muted-foreground">No posts found.</p>
            </div>
          )}
        </div>
      </Main>
    </>
  );
};

export const Route = createFileRoute('/')({
  errorComponent: ErrorComponent,
  component: Home,
  loader: async () => {
    return await getPostsServer();
  },
});
